/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Scope_Output5Inputs */

const en_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API contract`)
};

const ar_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عقد واجهة برمجية`)
};

const bn_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API কন্ট্রাক্ট`)
};

const de_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Vertrag`)
};

const es_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato API`)
};

const fr_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrat API`)
};

const pt_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrato de API`)
};

const zh_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 合约`)
};

const tr_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API sözleşmesi`)
};

const ru_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контракт API`)
};

const pl_svc_backend_development_scope_output5 = /** @type {(inputs: Svc_Backend_Development_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umowa API`)
};

/**
* | output |
* | --- |
* | "API contract" |
*
* @param {Svc_Backend_Development_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_scope_output5 = /** @type {((inputs?: Svc_Backend_Development_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_scope_output5(inputs)
	if (locale === "bn") return bn_svc_backend_development_scope_output5(inputs)
	if (locale === "de") return de_svc_backend_development_scope_output5(inputs)
	if (locale === "es") return es_svc_backend_development_scope_output5(inputs)
	if (locale === "fr") return fr_svc_backend_development_scope_output5(inputs)
	if (locale === "pt") return pt_svc_backend_development_scope_output5(inputs)
	if (locale === "zh") return zh_svc_backend_development_scope_output5(inputs)
	if (locale === "tr") return tr_svc_backend_development_scope_output5(inputs)
	if (locale === "ru") return ru_svc_backend_development_scope_output5(inputs)
	if (locale === "pl") return pl_svc_backend_development_scope_output5(inputs)
	return en_svc_backend_development_scope_output5(inputs)
});
export { svc_backend_development_scope_output5 as "svc_backend-development_SCOPE_output" }